import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface CompanyInfo {
  company_name: string;
  tagline: string;
  phone: string;
  email: string;
  address: string;
  about_text: string;
  business_hours: string;
  facebook_url: string;
  instagram_url: string;
}

const defaultValues: CompanyInfo = {
  company_name: "Morgan Land Company",
  tagline: "Your Gateway to Premium Properties",
  phone: "(555) 123-4567",
  email: "info@morganlandcompany.com",
  address: "123 Main Street, City, State 12345",
  about_text: "",
  business_hours: "Mon - Fri: 9am - 6pm, Sat: 10am - 4pm, Sun: Closed",
  facebook_url: "",
  instagram_url: "",
};

export function useCompanyInfo() {
  const { data, isLoading, error } = useQuery({
    queryKey: ["company-info"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("company_info")
        .select("key, value");
      
      if (error) throw error;
      
      const info: CompanyInfo = { ...defaultValues };
      data?.forEach((item) => {
        if (item.key in info) {
          (info as any)[item.key] = item.value || defaultValues[item.key as keyof CompanyInfo];
        }
      });
      
      return info;
    },
  });

  return {
    ...defaultValues,
    ...data,
    isLoading,
    error,
  };
}
